import { vehicleConstants } from "../actions/constants/vehicleConstants";

export const getVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.getVehicleRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.getVehicleSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.getVehicleFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const createVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleCreateRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleCreateSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.vehicleCreateFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const getVehicleParamsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.getVehicleParamsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.getVehicleParamsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.getVehicleParamsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const deleteVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleDeleteRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleDeleteSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledelete: action.payload };
    case vehicleConstants.vehicleDeleteFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const toggleVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleToggleRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleToggleSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicledata: action.payload };
    case vehicleConstants.vehicleToggleFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const vehicleViewReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleViewRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleViewSuccess:
      return { isLoading: false, isSuccess: true, isError: false, vehicle: action.payload };
    case vehicleConstants.vehicleViewFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const uploadVehicleReducer = (state = {}, action: any) => {
  switch (action.type) {
    case vehicleConstants.vehicleUploadRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case vehicleConstants.vehicleUploadSuccess:
      return { isLoading: false, isSuccess: true, isError: false, upload: action.payload };
    case vehicleConstants.vehicleUploadFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};
